import { css } from '@emotion/react'
import { Alert, colors, Link, Text, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { LoadingIndicator } from 'components/loading'
import theme from 'config/theme'
import { useHistoricoPlanosDeCuidadoQuery } from 'graphql/hooks.generated'
import { Fragment } from 'react'
import { useHistory, useRouteMatch } from 'react-router'
import { ResponsavelObservacaoModel } from 'view/atendimentos/atendimento-individual/atendimento-observacao/model-atendObservacao'

import { HistoricoPlanoCuidado } from './components/HistoricoPlanoCuidado'
import { PlanoCuidadoModel } from './model'
import { PlanoCuidadoRootView, urlPlanosDeCuidado } from './PlanoCuidadoRootView'

interface HistoricoPlanoCuidadoPanelProps {
  atendProfId: ID
  ultimoResponsavelPelaObservacao: ResponsavelObservacaoModel
}

export const HistoricoPlanoCuidadoPanel = (props: HistoricoPlanoCuidadoPanelProps) => {
  const { atendProfId, ultimoResponsavelPelaObservacao } = props

  const match = useRouteMatch()
  const history = useHistory()

  const {
    loading,
    data: { planosDeCuidado },
  } = useHistoricoPlanosDeCuidadoQuery({ variables: { atendProfId } })

  const numeroPlanosDeCuidado = planosDeCuidado?.length

  const planoCuidadoMaisRecente: PlanoCuidadoModel = planosDeCuidado?.[0]
  const atendProfIniciador =
    planoCuidadoMaisRecente?.atendimentoProfissionalObservacao.atendimentoObservacao.atendimentoProfissionalIniciador

  const renderConteudoPlanoCuidado = () => {
    if (loading) return <LoadingIndicator />

    if (numeroPlanosDeCuidado > 0) {
      const mostrarMaisDeUm = numeroPlanosDeCuidado > 1
      const quantidadeAdicional = Math.min(numeroPlanosDeCuidado - 1, 99)
      const textoLink = mostrarMaisDeUm
        ? `+${'plano'.pluralizeAndConcatValue(quantidadeAdicional)} de cuidado`
        : 'plano de cuidado'
      return (
        <VFlow vSpacing={0.5}>
          <HistoricoPlanoCuidado planoDeCuidado={planoCuidadoMaisRecente} />
          <Link tabIndex={0} onClick={() => history.push(`${match.url}${urlPlanosDeCuidado}`)} style={styles.link}>
            Ver {textoLink}
          </Link>
        </VFlow>
      )
    }

    return <Text fontStyle='italic'>Nenhum registro encontrado</Text>
  }

  return (
    <Fragment>
      <VFlow vSpacing={0.5}>
        <Alert type='info' inline>
          Os registros feitos neste atendimento estarão vinculados ao plano de cuidado da observação, sendo que o
          profissional responsável é {ultimoResponsavelPelaObservacao?.profissional.nome}.
        </Alert>
        <Box css={styles.box}>
          <VFlow vSpacing={0.5}>
            <Text fontWeight='bold'>Plano de cuidado mais recente da observação</Text>
            {renderConteudoPlanoCuidado()}
          </VFlow>
        </Box>
      </VFlow>
      <PlanoCuidadoRootView
        planosDeCuidado={planosDeCuidado}
        atendProfIniciador={atendProfIniciador}
        loading={loading}
      />
    </Fragment>
  )
}

const styles = {
  box: css`
    padding: 1rem;
    background: ${colors.gray.c90};
    border: 1px solid ${colors.gray.c80};
    border-radius: ${theme.radius.input}px;
  `,
  link: css`
    font-size: inherit;
  `,
}
